import { AppBar, Avatar, IconButton, Toolbar, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import logo from '../../assets/logo-dark-text.svg'
import EnvironmentBadge from '../_shared/components/env_badge/env_badge'
import { useUserContext } from 'domain/users/user_provider/user.provider'
import MenuOpenButton, {
  MenuOpenState,
} from 'presentation/layout/comstruct_menu/comstruct_menu_open_button'
import { HelpButton } from 'presentation/_shared/components/help_button/help_button'
import { PhoneButton } from 'presentation/_shared/components/phone_button/phone_button'

export interface HeaderProps {
  /** The current state of the menu and a function to set that state. */
  menuOpenState?: MenuOpenState
}

/**
 * Build the main Comstruct Header Toolbar.
 * @category General Layout
 */
export function Header(props: HeaderProps): JSX.Element {
  const { user } = useUserContext()
  return (
    <AppBar position='fixed' color='primary' className='no-print'>
      <Toolbar>
        <MenuOpenButton menuOpenState={props.menuOpenState} />
        <Typography
          variant='body1'
          noWrap
          component='div'
          color='white'
          onClick={() => (document.location = '/')}
          sx={{
            cursor: 'pointer',
          }}
        >
          <img
            alt='comstruct'
            src={logo}
            style={{ height: '40px', paddingTop: '7px' }}
          />
        </Typography>
        <Typography
          variant='body1'
          noWrap
          component='div'
          color='white'
          sx={{
            cursor: 'pointer',
            display: { flexGrow: 1, marginLeft: '30px' },
          }}
        ></Typography>
        <EnvironmentBadge />
        <HelpButton />
        <PhoneButton />
        <IconButton component={Link} to={'/profile'} color='inherit'>
          <Avatar src={user.picture} alt='user avatar'></Avatar>
        </IconButton>
      </Toolbar>
    </AppBar>
  )
}
